module.exports = __webpack_public_path__ + "img/bg-hen.848a5dd9.png";